import { getRepository, getRepositoryTags } from "@prismicio/editor-fields"
import { request } from "@prismicio/editor-support/Http"
import {
  invalidateFetcherData,
  preload,
  useRequest
} from "@prismicio/editor-support/Suspense"
import { z } from "zod"

import { env } from "../env"
import { baseUrl as coreApiBaseUrl } from "./core"

export function useRepository() {
  return useRequest(getRepository, [
    coreApiBaseUrl,
    env.PAGE_BUILDER_AUTH_STRATEGY
  ])
}

export function preloadRepository() {
  preload(getRepository, [coreApiBaseUrl, env.PAGE_BUILDER_AUTH_STRATEGY])
}

export function setSimulatorURL(simulator_url: string) {
  const body = { simulator_url }
  return request(new URL("repository", coreApiBaseUrl), {
    method: "PATCH",
    body,
    okType: z.unknown()
  })
}

export function useRepositoryTags() {
  return useRequest(getRepositoryTags, [
    coreApiBaseUrl,
    env.PAGE_BUILDER_AUTH_STRATEGY
  ])
}

export function invalidateRepositoryTags() {
  invalidateFetcherData(getRepositoryTags)
}
